import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { PermModule, AccessLevel } from '@playq/octopus2-auth';
import { Environment } from '@playq/octopus-common';

import { IModulePerms, IPermissionsAccess, appToolkit } from '/store';
import { IWithReadonly } from '/common/models';

const getPermission = (
  { canWrite, canWriteLive, env, access }: IModulePerms & { env: Environment; access: IPermissionsAccess },
  permModule: PermModule
) => ({
  canWrite,
  canWriteLive,
  readonly: env === Environment.Live ? !canWriteLive : !canWrite,
  canRead: access[permModule] !== AccessLevel.None,
});

// overloads
export function useModulePermissions(module: PermModule, defaultEnv?: Environment): IWithReadonly<IModulePerms>;
export function useModulePermissions(module: PermModule[], defaultEnv?: Environment): IWithReadonly<IModulePerms>[];

// implementation
export function useModulePermissions(
  module: PermModule[] | PermModule,
  defaultEnv?: Environment
): IModulePerms[] | IModulePerms {
  const isMulti = Array.isArray(module);

  const access = useSelector(appToolkit.selectors.accessScope);
  const modulePerms = useSelector(appToolkit.selectors.moduleAccess(isMulti ? module[0] : module));

  const params = useParams<{ env: Environment }>();
  const env = defaultEnv ?? params?.env;

  const getPermissionParamsBase = { ...modulePerms, env, access };

  return isMulti
    ? module.map(getPermission.bind(null, getPermissionParamsBase))
    : getPermission(getPermissionParamsBase, module);
}
